import React, { memo, forwardRef } from 'react'
import style from './ScaleButton.module.scss'
import PropTypes from 'prop-types'

const ScaleButtons = forwardRef((props, ref) => {
  const { fullscreen, scale, updateScale } = props

  return (
    <div
      ref={ref}
      className={`${style.scaleButtons} ${fullscreen ? style.Fullscreen : ''}`}
      data-testid="SW-SH-ScaleButtons"
    >
      <button
        data-testid="SW-SH-ScaleButton-Plus"
        className={`${style.zoomButton} ${style.Plus}`}
        disabled={scale > 3}
        onClick={() => updateScale(scale + 0.1)}
      >
        +
      </button>
      <button
        data-testid="SW-SH-ScaleButton-Minus"
        className={`${style.zoomButton} ${style.Minus}`}
        disabled={scale <= 1}
        onClick={() => updateScale(scale - 0.1)}
      >
        -
      </button>
    </div>
  )
})

ScaleButtons.displayName = 'ScaleButtons'

ScaleButtons.propTypes = {
  fullscreen: PropTypes.bool,
  scale: PropTypes.number,
  updateScale: PropTypes.func
}

export default memo(
  ScaleButtons,
  (prevProps, nextProps) =>
    prevProps.fullscreen === nextProps.fullscreen &&
    prevProps.scale === nextProps.scale &&
    prevProps.updateScale === nextProps.updateScale
)
